import { render, staticRenderFns } from "./angentDetail.vue?vue&type=template&id=77069392&scoped=true"
import script from "./angentDetail.vue?vue&type=script&lang=js"
export * from "./angentDetail.vue?vue&type=script&lang=js"
import style0 from "./angentDetail.vue?vue&type=style&index=0&id=77069392&prod&scoped=true&lang=scss"
import style1 from "./angentDetail.vue?vue&type=style&index=1&id=77069392&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77069392",
  null
  
)

export default component.exports